import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  name: "DiscountTypeDetail",

  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      noDataMsg: "No Data Found",
      isLoading: false,
      discountTypeData: {},
      studentOptions: [], 
      CONFIG
    };
  },

  computed: {
    discountTypeText() {
      return this.CONFIG.DISCOUNT_TYPES_TEXT[
        this.discountTypeData.discount_type
      ] || "";
    },
    statusText() {
      return this.CONFIG.DISCOUNT_STATUS_TEXT[
        this.discountTypeData.is_active
      ] || "";
    },
    /**
     * Resolve stored flags to Discount Category label (matches create/edit radios).
     */
    discountCategoryText() {
      if (this.discountTypeData.is_lifetime) {
        return "Lifetime Discount";
      }
      if (this.discountTypeData.is_special_discount) {
        return "Special Discount";
      }
      return "None";
    },
    formattedDiscountAmount() {
      if (this.discountTypeData.discount_type === this.CONFIG.DISCOUNT_TYPE.PERCENTAGE) {
        return this.discountTypeData.discount_amount + ' %';
      }
      return this.discountTypeData.discount_amount ? this.$options.filters.numFormat(this.discountTypeData.discount_amount) : '';
    },
    selectedStudentNames() {
        if (!this.discountTypeData.student_ids || this.studentOptions.length === 0) {
          return [];
        }
        const selectedIds = this.discountTypeData.student_ids.toString().split(/,|\n/).map(id => id.trim()).filter(id => id !== "");
        return this.studentOptions.filter(student => {
            const sId = student.id?.toString() || "";
            return selectedIds.includes(sId);
          }).map(student => student.text);
    }
  },

  methods: {
    loadStudents() {
      const campus_id = this.$store.state.user.campus_id;
      axios.get(`/student/dropdown`, { params: { campus_id } })
        .then(res => {
          this.studentOptions = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => console.error("Failed to load students:", err));
    },
    getDiscountTypeById() {
      const id = this.$route.params.id;
      if (!/^\d+$/.test(id)) {
        this.discountTypeData = {};
        return;
      }
      this.isLoading = true;
      axios.get(`/discountType/detail/${id}`)
        .then((response) => {
          if (response.data) {
            this.discountTypeData = response.data || {};
          }
        })
        .catch((error) => {
          this.discountTypeData = {};
          if (error.response && error.response.status === 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          } else {
            console.error("Error fetching discount type detail:", error);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showList() {
      this.$router.push({
        path: "/discountType/list"
      });
    }
  },
  mounted() {
    this.getDiscountTypeById();
    this.loadStudents(); 
  }
};
